import styled from 'styled-components';
import colors from 'styles/colors';

export const StyledLabel = styled.label`
  display: block;
  width: auto;
  height: auto;
  font-size: 18px;
  line-height: 1;
  color: ${colors.Gray20};
`;